import React from 'react';

// styles
import {
    StepContainer,
    StepIndicator,
    StepHeader,
    StepTitle,
    ComingSoon,
    StepDescription
} from './StepThree.styles.js';

export default function StepThree() {
    return (
        <StepContainer>
            <StepIndicator>3</StepIndicator>
            <StepHeader>
                <StepTitle>
                    Manage your collection <ComingSoon>(Coming Soon!)</ComingSoon>
                </StepTitle>
                <StepDescription>
                    Create sets, track sales, and monitor PSA submissions
                </StepDescription>
            </StepHeader>
        </StepContainer>
    );
}
